<!-- ============================================================
     CIRCLEDPLUS SEARCH & FILTERS
     Premium Search Experience
============================================================ -->

<div class="filter-wrapper">

  <div class="search-filter-container">

    <form [formGroup]="form">

      <!-- ======================================================
           SEARCH SURFACE
      ======================================================= -->

      <div class="search-row">

        <!-- ====================================================
             SEARCH INPUT
        ===================================================== -->

        <div
          class="location-search"
          (click)="$event.stopPropagation()"
        >

          <!-- Search / Location Icon -->

          <span class="search-icon" aria-hidden="true">
            <i class="fas fa-search"></i>
          </span>


          <!-- Input -->

          <input
            type="text"
            formControlName="location"
            placeholder="Search by location, project, or landmark..."
            class="location-search-input"
            autocomplete="off"
            (keydown.enter)="$event.preventDefault(); searchByText()"
          />


          <!-- Clear -->

          <button
            *ngIf="form.value.location"
            type="button"
            class="search-clear-button"
            aria-label="Clear search"
            (click)="clearAppliedFilters()"
          >
            <i class="fas fa-times"></i>
          </button>


          <!-- ==================================================
               AUTOCOMPLETE
          =================================================== -->

          <div
            *ngIf="
              showLocationDropdown &&
              selectedLocations.length < 3
            "
            class="location-dropdown"
          >

            <div
              *ngFor="let item of filteredLocations"
              class="location-dropdown-item"
              (click)="selectSearchItem(item)"
            >

              <!-- Location -->

              <ng-container *ngIf="item.type === 'location'">

                <span class="dropdown-icon location-icon">
                  <i class="fas fa-location-dot"></i>
                </span>

                <span class="dropdown-content">
                  <small>Location</small>
                  <strong>{{ item.label }}</strong>
                </span>

              </ng-container>


              <!-- Property -->

              <ng-container *ngIf="item.type === 'property'">

                <span class="dropdown-icon property-icon">
                  <i class="fas fa-building"></i>
                </span>

                <span class="dropdown-content">
                  <small>Property</small>
                  <strong>{{ item.label }}</strong>
                </span>

              </ng-container>

            </div>

          </div>

        </div>


        <!-- ====================================================
             FILTER TRIGGER
        ===================================================== -->

        <button
          type="button"
          class="filter-trigger"
          (click)="toggleFilters()"
          aria-label="Open property filters"
        >

          <span class="filter-trigger-icon">
            <i class="fas fa-sliders-h"></i>
          </span>

          <span class="filter-trigger-text">
            Filters
          </span>

          <span
            *ngIf="hasAppliedFilters()"
            class="filter-count"
          >
            {{ appliedFilterCount }}
          </span>

        </button>

      </div>


      <!-- ======================================================
           APPLIED FILTERS
      ======================================================= -->

      <div
        *ngIf="hasAppliedFilters()"
        class="applied-filter-list"
      >

        <!-- ====================================================
             LOCATIONS
        ===================================================== -->

        <div
          *ngFor="
            let location of selectedLocations;
            let i = index
          "
          class="applied-filter-chip location-chip"
        >

          <span class="chip-icon">
            <i class="fas fa-location-dot"></i>
          </span>

          <span class="chip-text">
            {{ location }}
          </span>

          <button
            type="button"
            aria-label="Remove location"
            (click)="removeAppliedLocation(i)"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- ====================================================
             PROPERTY TYPE
        ===================================================== -->

        <div
          *ngFor="let v of appliedFilters.propertyType"
          class="applied-filter-chip"
        >

          <span class="chip-text">
            {{ v }}
          </span>

          <button
            type="button"
            aria-label="Remove property type"
            (click)="removeAppliedChip('propertyType', v)"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- ====================================================
             UNIT TYPE
        ===================================================== -->

        <div
          *ngFor="let v of appliedFilters.unitTypes"
          class="applied-filter-chip"
        >

          <span class="chip-text">
            {{ v }}
          </span>

          <button
            type="button"
            aria-label="Remove unit type"
            (click)="removeAppliedChip('unitTypes', v)"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- ====================================================
             BHK
        ===================================================== -->

        <div
          *ngFor="let v of appliedFilters.bhk"
          class="applied-filter-chip"
        >

          <span class="chip-text">
            {{ v }}
          </span>

          <button
            type="button"
            aria-label="Remove BHK filter"
            (click)="removeAppliedChip('bhk', v)"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- ====================================================
             STATUS
        ===================================================== -->

        <div
          *ngFor="let v of appliedFilters.status"
          class="applied-filter-chip"
        >

          <span class="chip-text">
            {{ v }}
          </span>

          <button
            type="button"
            aria-label="Remove status filter"
            (click)="removeAppliedChip('status', v)"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- ====================================================
             BUDGET
        ===================================================== -->

        <div
          *ngIf="
            form.value.minBudget !== 1 ||
            form.value.maxBudget !== 100
          "
          class="applied-filter-chip budget-chip"
        >

          <span class="chip-icon">
            <i class="fas fa-indian-rupee-sign"></i>
          </span>

          <span class="chip-text">
            ₹ {{ form.value.minBudget }} – {{ form.value.maxBudget }} Cr
          </span>

          <button
            type="button"
            aria-label="Remove budget filter"
            (click)="removeBudgetFilter()"
          >
            <i class="fas fa-times"></i>
          </button>

        </div>


        <div *ngFor="let value of appliedFilters.ciVerdict" class="applied-filter-chip">
          <span class="chip-text">{{ ciFilterLabel(value) }}</span>
          <button type="button" [attr.aria-label]="'Remove ' + ciFilterLabel(value)" (click)="removeAppliedChip('ciVerdict', value)"><i class="fas fa-times"></i></button>
        </div>
        <div *ngFor="let value of appliedFilters.advancedCi" class="applied-filter-chip">
          <span class="chip-text">{{ ciFilterLabel(value) }}</span>
          <button type="button" [attr.aria-label]="'Remove ' + ciFilterLabel(value)" (click)="removeAppliedChip('advancedCi', value)"><i class="fas fa-times"></i></button>
        </div>

        <!-- ====================================================
             CLEAR ALL
        ===================================================== -->

        <button
          type="button"
          class="clear-filters-link"
          (click)="clearAppliedFilters()"
        >
          Clear all
        </button>

      </div>


      <!-- ======================================================
           FILTER OVERLAY
      ======================================================= -->

      <div
        *ngIf="isFilterOpen"
        class="filter-overlay"
        (click)="closeFilters()"
      >

        <!-- ====================================================
             FILTER MODAL
        ===================================================== -->

        <div
          class="filter-modal"
          role="dialog" aria-modal="true" aria-labelledby="filter-dialog-title"
          (click)="$event.stopPropagation()"
        >

          <!-- ==================================================
               MODAL HEADER
          =================================================== -->

          <div class="filter-modal-header">
            <button type="button" class="filter-dialog-close" aria-label="Close filters" (click)="cancelFilters()"><i class="fas fa-times" aria-hidden="true"></i></button>

            <div class="filter-header-copy">

              <span class="filter-header-eyebrow">
                Property Search
              </span>

              <h2 id="filter-dialog-title" class="filter-modal-title">
                Refine your search
              </h2>

              <p class="filter-modal-subtitle">
                Choose a category to refine your search.
              </p>
              <div *ngIf="draftFilterChips.length" class="draft-filter-summary" aria-label="Selected filters">
                <span class="draft-filter-label">Selected filters</span>
                <span *ngFor="let chip of draftFilterChips" class="draft-filter-chip">
                  {{ chip.label }}
                  <button type="button" class="draft-chip-remove" [attr.aria-label]="'Remove ' + chip.label" (click)="removeDraftChip(chip)"><span aria-hidden="true">×</span></button>
                </span>
              </div>

            </div>




          </div>


          <!-- ==================================================
               MODAL BODY
          =================================================== -->

          <div class="filter-modal-body">
            <nav class="filter-category-nav" role="tablist" aria-label="Filter categories" aria-orientation="vertical">
              <button *ngFor="let category of filterCategories; let i = index" type="button" role="tab"
                [id]="'filter-category-' + category.key" [attr.aria-controls]="'filter-panel-' + category.key"
                [attr.aria-selected]="activeFilter === category.key" [tabIndex]="activeFilter === category.key ? 0 : -1"
                [class.active]="activeFilter === category.key" (click)="activeFilter = category.key" (keydown)="onCategoryKeydown($event, i)">
                <span>{{ category.label }}</span><span *ngIf="categoryCount(category.key)" class="category-count">{{ categoryCount(category.key) }}</span>
                <i *ngIf="category.key === 'advancedCi' && !ciPaidAccess" class="fas fa-lock" aria-hidden="true"></i>
              </button>
            </nav>
            <div class="filter-category-content">
            <section class="filter-section" [hidden]="activeFilter !== 'propertyType'" id="filter-panel-propertyType" role="tabpanel" aria-labelledby="filter-category-propertyType">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Category
                  </span>

                  <h3 class="filter-section-title">
                    Property Type
                  </h3>
                </div>

              </div>


              <div class="filter-options">

                <button
                  *ngFor="let t of propertyTypes"
                  type="button"
                  class="filter-option"
                  [class.selected]="
                    form.value.propertyType.includes(t)
                  "
                  (click)="toggleValue('propertyType', t)"
                >
                  {{ t }}
                </button>

              </div>

            </section>


            <!-- =================================================
                 UNIT TYPE
            ================================================== -->

            <section class="filter-section" [hidden]="activeFilter !== 'unitTypes'" id="filter-panel-unitTypes" role="tabpanel" aria-labelledby="filter-category-unitTypes">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Configuration
                  </span>

                  <h3 class="filter-section-title">
                    Unit Type
                  </h3>
                </div>

              </div>


              <div class="filter-options">

                <button
                  *ngFor="let u of unitTypes"
                  type="button"
                  class="filter-option"
                  [class.selected]="
                    form.value.unitTypes.includes(u)
                  "
                  (click)="toggleValue('unitTypes', u)"
                >
                  {{ u }}
                </button>

              </div>

            </section>


            <!-- =================================================
                 CIRCLEDPLUS TAG
            ================================================== -->

            <section class="filter-section" [hidden]="activeFilter !== 'tagType'" id="filter-panel-tagType" role="tabpanel" aria-labelledby="filter-category-tagType">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Intelligence
                  </span>

                  <h3 class="filter-section-title">
                    CircledPlus Tag
                  </h3>
                </div>

              </div>


              <div class="filter-options">

                <button
                  *ngFor="let item of tagType"
                  type="button"
                  class="filter-option"
                  [class.selected]="
                    form.value.tagType.includes(item.value)
                  "
                  (click)="toggleValue('tagType', item.value)"
                >
                  {{ item.name }}
                </button>

              </div>

            </section>


            <!-- =================================================
                 BUDGET
            ================================================== -->

            <section class="filter-section budget-section" [hidden]="activeFilter !== 'budget'" id="filter-panel-budget" role="tabpanel" aria-labelledby="filter-category-budget">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Investment Range
                  </span>

                  <h3 class="filter-section-title">
                    Budget
                  </h3>
                </div>

              </div>


              <!-- Budget Values -->

              <div class="budget-values">

                <div class="budget-value">

                  <span class="budget-value-label">
                    Minimum
                  </span>

                  <strong class="budget-value-amount">
                    ₹ {{ form.value.minBudget }} Cr
                  </strong>

                </div>


                <div class="budget-value">

                  <span class="budget-value-label">
                    Maximum
                  </span>

                  <strong class="budget-value-amount">
                    ₹ {{ form.value.maxBudget }} Cr{{ form.value.maxBudget === 100 ? '+' : '' }}
                  </strong>

                </div>

              </div>


              <!-- Slider -->

              <div class="budget-slider">

                <div class="budget-track"></div>

                <div
                  class="budget-active-track"
                  [style.left.%]="
                    ((form.value.minBudget - 1) / 99) * 100
                  "
                  [style.right.%]="
                    100 -
                    (
                      ((form.value.maxBudget - 1) / 99) * 100
                    )
                  "
                ></div>


                <!-- Minimum -->

                <input
                  type="range"
                  min="1"
                  max="100"
                  step="0.5"
                  formControlName="minBudget"
                  [style.z-index]="form.value.minBudget >= 99 ? 12 : 10"
                  (input)="onBudgetInput('minBudget', $event)"
                  aria-label="Minimum budget"
                />


                <!-- Maximum -->

                <input
                  type="range"
                  min="1"
                  max="100"
                  step="0.5"
                  formControlName="maxBudget"
                  (input)="onBudgetInput('maxBudget', $event)"
                  aria-label="Maximum budget"
                />

              </div>


              <div class="budget-range-labels">

                <span>
                  ₹ 1 Cr
                </span>

                <span>
                  ₹ 100 Cr+
                </span>

              </div>

            </section>


            <!-- =================================================
                 BHK
            ================================================== -->

            <section class="filter-section" [hidden]="activeFilter !== 'bhk'" id="filter-panel-bhk" role="tabpanel" aria-labelledby="filter-category-bhk">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Home Size
                  </span>

                  <h3 class="filter-section-title">
                    BHK Configuration
                  </h3>
                </div>

              </div>


              <div class="filter-grid">

                <button
                  *ngFor="let b of bhkTypes"
                  type="button"
                  class="filter-option"
                  [class.selected]="
                    form.value.bhk.includes(b)
                  "
                  (click)="toggleValue('bhk', b)"
                >
                  {{ b }}
                </button>

              </div>

            </section>


            <!-- =================================================
                 STATUS
            ================================================== -->

            <section class="filter-section" [hidden]="activeFilter !== 'status'" id="filter-panel-status" role="tabpanel" aria-labelledby="filter-category-status">

              <div class="filter-section-heading">

                <div>
                  <span class="filter-section-kicker">
                    Availability
                  </span>

                  <h3 class="filter-section-title">
                    Property Status
                  </h3>
                </div>

              </div>


              <div class="filter-grid">

                <button
                  *ngFor="let s of statusTypes"
                  type="button"
                  class="filter-option"
                  [class.selected]="
                    form.value.status.includes(s)
                  "
                  (click)="toggleValue('status', s)"
                >
                  {{ s }}
                </button>

              </div>

            </section>

            <section class="filter-section" [hidden]="activeFilter !== 'ciVerdict'" id="filter-panel-ciVerdict" role="tabpanel" aria-labelledby="filter-category-ciVerdict">
              <div class="filter-section-heading"><div><span class="filter-section-kicker">Circled Intelligence (CI)</span><h3 class="filter-section-title">CI Verdict</h3></div><span class="ci-access-badge">For everyone</span></div>
              <p class="ci-filter-upgrade" role="note">CI filtering is coming soon. Your other filters apply normally.</p>
              <div class="filter-grid">
                <button *ngFor="let option of ciVerdictOptions" type="button" class="filter-option" [class.selected]="form.value.ciVerdict.includes(option.value)" [attr.aria-pressed]="form.value.ciVerdict.includes(option.value)" (click)="toggleValue('ciVerdict', option.value)">{{ option.label }}</button>
              </div>
            </section>
            <section class="filter-section" [hidden]="activeFilter !== 'advancedCi'" id="filter-panel-advancedCi" role="tabpanel" aria-labelledby="filter-category-advancedCi">
              <div class="filter-section-heading"><div><span class="filter-section-kicker">Go deeper</span><h3 class="filter-section-title">Advanced CI filters</h3></div><span class="ci-access-badge">Intelligence &amp; Advisory</span></div>
              <div class="filter-grid ci-advanced-options">
                <div *ngFor="let option of advancedCiOptions" class="ci-option-tooltip" [class.has-tooltip]="option.value === 'udsSupportAbove' && plotSelected" [attr.tabindex]="option.value === 'udsSupportAbove' && plotSelected ? 0 : null" [attr.aria-label]="option.value === 'udsSupportAbove' && plotSelected ? 'UDS Support is unavailable for plots' : null">
                  <button type="button" class="filter-option" [disabled]="!ciPaidAccess || (option.value === 'udsSupportAbove' && plotSelected)" [class.selected]="form.value.advancedCi.includes(option.value)" [attr.aria-pressed]="form.value.advancedCi.includes(option.value)" (click)="toggleValue('advancedCi', option.value)"><i *ngIf="!ciPaidAccess" class="fas fa-lock" aria-hidden="true"></i> {{ option.label }}</button>
                  <span *ngIf="option.value === 'udsSupportAbove' && plotSelected" class="uds-filter-tooltip" role="tooltip">UDS Support does not apply to plots. Deselect Plot to use this filter.</span>
                </div>
              </div>
              <p *ngIf="!ciPaidAccess" class="ci-filter-upgrade">Use an Intelligence or Advisory plan to filter by yield, benchmark pricing, and land support. <a routerLink="/payment" [queryParams]="{plan: 'intelligence'}">Explore plans →</a></p>
            </section>

            </div>
          </div>


          <!-- ==================================================
               MODAL FOOTER
          =================================================== -->

          <div class="filter-modal-footer">

            <button
              type="button"
              class="filter-clear-button"
              (click)="clearAll()"
            >
              Clear all
            </button>


            <button
              type="button"
              class="filter-apply-button"
              (click)="applyFilters()"
            >
              <span>Apply Filter</span>

              <i class="fas fa-arrow-right"></i>
            </button>

          </div>

        </div>

      </div>

    </form>

  </div>

</div>
